module.exports = __webpack_public_path__ + "static/media/droids.28903be8.jpg";